import Vue from 'vue'
import './plugins/axios'
import './assets/css/main.css'
import './assets/css/squarespace.css'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
